import gql from 'graphql-tag'

export const INSTANT_ENROLL_QUERY = gql`
  query InstantEnrollQuery {
    user {
      id
      familyId
    }
  }
`
